import { Box, Container, Grid, Typography } from "@mui/material";
import type { NextPage } from "next";
import Head from "next/head";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IReduxState } from "../../redux/app_store";
import { PricingPlanExternal } from "../../components/stripe/PricingPlanExternal";

const ShareSubscription: NextPage = () => {
  const { t } = useTranslation();
  const { userFlags } = useSelector((store: IReduxState) => store);

  const plans = [
    {
      cta:
        userFlags?.tier === "free"
          ? t("pricing_table__general__subscription_state_label__current_plan")
          : t("pricing_table__general__subscription_state_label__higher_plan"),
      name: t("pricing_table__general__name__enterprise"),
      description: t("pricing_table__plans__starter_plan__description"),
      priceDescription: t("pricing_table__plans__starter_plan__price_subtitle"),
      featuresTitle: t("pricing_table__features__title"),
      previousPrice: null,
      features: [
        {
          describe: t("pricing_table__features__options__item_1"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_2"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_3"),
          include: true,
        },
      ],
      disabled: true,
      price: 0,
      payment: null,
      bestPrice: false,
    },

    {
      cta:
        userFlags?.tier === "pro"
          ? t("pricing_table__general__subscription_state_label__current_plan")
          : t("pricing_table__general__subscription_state_label__get_pro_plan"),
      name: t("pricing_table__general__name__pro"),
      chipLabel: t("pricing_table__general__labels__discount_label", {
        discountAmount: 63,
      }),
      description: t("pricing_table__plans__pro_plan__description"),
      priceDescription: t("pricing_table__plans__pro_plan__price_subtitle"),
      featuresTitle: t("pricing_table__features__title"),
      features: [
        {
          describe: t("pricing_table__features__options__item_7"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_15"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_9"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_10"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_16"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_18"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_19"),
          include: true,
        },
      ],
      previousPrice: 1199,
      price: 449,
      popular:
        userFlags?.tier === "premium" || userFlags?.tier === "pro"
          ? false
          : true,
      disabled:
        userFlags?.tier === "premium" || userFlags?.tier === "pro"
          ? true
          : false,
      payment: "annually",
      bestPrice: true,
    },
    {
      cta:
        userFlags?.tier === "premium"
          ? t("pricing_table__general__subscription_state_label__current_plan")
          : userFlags?.tier === "pro"
          ? t("pricing_table__general__subscription_state_label__higher_plan")
          : t(
              "pricing_table__general__subscription_state_label__get_premium_plan"
            ),
      name: t("pricing_table__general__name__premium"),
      chipLabel: t("pricing_table__general__labels__discount_label", {
        discountAmount: 38,
      }),
      description: t("pricing_table__plans__premium_plan__description"),
      priceDescription: t("pricing_table__plans__premium_plan__price_subtitle"),
      featuresTitle: t("pricing_table__features__title"),
      features: [
        {
          describe: t("pricing_table__features__options__item_7"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_8"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_9"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_10"),
          include: true,
        },
        {
          describe: t("pricing_table__features__options__item_11"),
          include: true,
        },
      ],
      previousPrice: 1199,
      price: 749,
      payment: "quarterly",
      bestPrice: false,
      disabled:
        userFlags?.tier === "premium" || userFlags?.tier === "pro"
          ? true
          : false,
    },
  ];

  return (
    <>
      <Head>
        <title>Parsly</title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
          backgroundColor: "#FFF",
        }}
      >
        <Container id="pricing-plan-external" maxWidth="xl">
          <>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                mb: 4,
              }}
            >
              <Typography color="text.secondary" sx={{ my: 2 }} variant="body1">
                {t("pricing_table__general__labels__page_description")}
              </Typography>
            </Box>
            <Grid container spacing={2}>
              {plans.map((plan) => (
                <Grid
                  item
                  xs={12}
                  md={4}
                  sx={{ height: "100%" }}
                  key={plan?.name}
                >
                  <PricingPlanExternal
                    cta={plan?.cta}
                    icon={null}
                    description={plan?.description}
                    features={plan?.features}
                    name={plan?.name}
                    price={plan?.price}
                    yearlyPayment={plan.payment}
                    disabled={plan?.disabled ? true : false}
                    popular={plan?.popular ? true : false}
                    priceDescription={plan?.priceDescription}
                    featuresTitle={plan?.featuresTitle}
                    previousPrice={plan?.previousPrice}
                    chipLabel={plan?.chipLabel}
                    bestPrice={plan?.bestPrice}
                    sx={{
                      height: "100%",
                      //maxWidth: 460,
                      mx: "auto",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        </Container>
      </Box>
    </>
  );
};

export default ShareSubscription;
